import { useContext } from 'react';
import { YearViewContext } from 'src/sections/view_checkbook/YearViewContext';

const useYearView = () => {
  const context = useContext(YearViewContext);
  if (!context) throw new Error('Year View context must be used inside YearViewContextProvider');
  return context;
};

export default useYearView;
